import { cached } from '@porotutu/react'
import { listQueryOf } from '@porotutu/react/paging'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { permittedRoute, signedInRoute } from '@/router/root'
import { CRM_REWARD_SORTABLE, REWARD_FILTERS, REWARD_TYPES } from '../vocabulary'
import { rewardQuery, rewardsQuery } from './queries'

const rewardSearch = (raw: Record<string, unknown>) =>
  listQueryOf(raw, CRM_REWARD_SORTABLE, [], REWARD_FILTERS, { reward_type: REWARD_TYPES })

export const rewardsRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('rewards'),
  path: '/rewards',
  validateSearch: rewardSearch,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => context.queryClient.query(cached(rewardsQuery(deps))),
  component: lazyRouteComponent(() => import('./pages'), 'RewardsPage'),
})

export const rewardRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('rewards'),
  path: '/rewards/$id',
  validateSearch: rewardSearch,
  loader: ({ context, params }) => context.queryClient.query(cached(rewardQuery(params.id))),
  component: lazyRouteComponent(() => import('./pages'), 'RewardPage'),
})

export const rewardRoutes = [rewardsRoute, rewardRoute]
